<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-4 p-mr-4 p-mb-2">
        <div class="p-formgrid p-grid p-col-12 p-ml-2">
            <div class="p-col-12 p-lg-8 p-mt-3">
              <label>{{ $t("iv_victim_status") }}</label>
              <div class="p-formgrid p-grid p-col p-mt-3">
                <div class="p-field-checkbox p-mr-4">
                  <Checkbox
                    id="check_level_0"
                    name="check_0"
                    value="0"
                    v-model="checked"
                  />
                  <label>ไม่ระบุ</label>
                </div>
                <div class="p-field-checkbox p-mr-4">
                  <Checkbox
                    id="check_level_1"
                    name="check_1"
                    value="gs-99die"
                    v-model="checked"
                  />
                  <label>เสียชีวิต</label>
                </div>
                <div class="p-field-checkbox p-mr-4">
                  <Checkbox
                    id="check_level_12"
                    name="check_2"
                    value="gs-99hurt"
                    v-model="checked"
                  />
                  <label>บาดเจ็บ</label>
                </div>
                <div class="p-field-checkbox p-mr-4">
                  <Checkbox
                    id="check_level_3"
                    name="check_3"
                    value="gs-99lost"
                    v-model="checked"
                  />
                  <label>สูญหาย</label>
                </div>
              </div>
            </div>

            <div class="p-col-12 p-lg-4">
              <div class="p-formgrid p-grid p-mt-4 p-jc-end">
                <div class="p-field p-col p-mt-2">
                   <!-- <Button
                    @click="exportCSV()"
                    :label="$t('exportBtn')"
                    class="p-button-info p-mr-3"
                    style="background-color: green;"
                  /> -->
                  <Button
                    @click="clearSearchField()"
                    :label="$t('clearBtn')"
                    class="p-button-clear p-mr-3"
                  />
                  <Button
                    @click="search()
                    cou =true"
                    :label="$t('searchBtn')"
                    class="p-button-info p-mr-2"
                  />
                </div>
              </div>
            </div>
        </div>
        <hr />
        <div class="p-formgrid p-grid p-col">
          <div class="p-col-12 p-lg-5 p-mr-3">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10">
                <label class="p-mr-2">{{ $t("iv_victim_disaster") }}</label>
                <Button
                  @click="showDisasterEvent = true"
                  icon="pi pi-plus"
                  class="p-button-success"
                />
              </div>
            </div>
            <div class="p-field p-col p-mt-2" style="margin-left: -10px">
              <DataTable
                :value="event_table"
                :scrollable="true"
                scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                ref="dt"
                :rowHover="true"
               
                :selection.sync="selectedEventData"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="event_date"
                  :header="$t('imp_date')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">  
                    <div hidden>{{ dataTable.data.hazard_id }}</div>
                    {{ formatDateTH(dataTable.data.event_date) }}
                  </template>
                </Column>
                <Column
                  field="event_name"
                  :header="$t('event_name')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.event_name }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col-6">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            eventDelete = dataTable.data;
                            alertDisplay(eventDelete)
                          "
                          icon="pi pi-trash"
                          :label="$t('deleteBtn')"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>

          <div class="p-col-12 p-lg-6 ">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10">
                <label class="p-mr-2">{{ $t("address_locate") }}</label>
                <Button
                  @click="showResponseArea = true"
                  icon="pi pi-plus"
                  class="p-button-success"
                />
              </div>
            </div>
            <div class="p-field p-col p-mt-2" style="margin-left: -10px">
              <DataTable
                :value="responseArea_table"
                :scrollable="true"
      scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                ref="dt"
                :rowHover="true"
                
                :selection.sync="selectedResponseAreaData"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="province_name"
                  :header="$t('province')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    <div hidden>{{ dataTable.data.tambon_id }}</div>
                    {{ dataTable.data.province_name }}
                  </template>
                </Column>
                <Column
                  field="amphur_name"
                  :header="$t('amphur')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.amphur_name }}
                  </template>
                </Column>
                <Column
                  field="tambon_name"
                  :header="$t('tambon')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.tambon_name }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            responseAreaDelete = dataTable.data;
                            alertDisplay(displayConfirmation)
                          "
                          icon="pi pi-trash"
                          :label="$t('deleteBtn')"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
        </div>
        <div class="p-formgrid p-grid p-col p-mt-1">
              <text-footer
                :data="Data_text_Footer"
                :checkShow="text_Footer"
                :countItem="table.length.toLocaleString('en-US')"
              />
        </div>
      </div>
    </Fieldset>

    <Dialog  :modal="true"
      :header="$t('disasterEventModalHeader')"
      :visible.sync="showDisasterEvent"
      :contentStyle="{ 'overflow-y': 'scroll' }"
      :style="{ width: '85%' }"
    >
      <disaster-event-multiselect
        @selectEvent="selectedEvent_passValue" :parentmessage="parentmessage_event"
      ></disaster-event-multiselect>
    </Dialog>

    <Dialog  :modal="true"
      header="ค้นหาข้อมูลพื้นที่ตามที่อยู่"
      :visible.sync="showResponseArea"
      :style="{ width: '80%' }"
      :contentStyle="{'overflow-y': 'scroll'}"
    >
      <response-area-table
        @selectResponseArea="selectResponseArea_passValue" :parentmessage="parentmessage_area"
      ></response-area-table>
    </Dialog>

    <div class="card p-fluid p-mt-2">
      <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
      <DataTable
        :value="table"
        :scrollable="true"
      scrollHeight="500px"
        :paginator="true"
        :rows="10"
        dataKey="id"
        :sortOrder="1"
        sortField="index"
        ref="dt"
        :exportFilename = "`รายละเอียด-${date}`"
        :rowHover="true"
        :filters="filters"
        :loading="loading"
       
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
      <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
      <template #header>
          <div class="p-grid p-col ">
            <!-- Doe : PDF 1/3 -->
            <div class="table-header "  style="padding: 7px;"   >
              <Button
                    
                    @click="exportCSV()"
                    :label="$t('exportBtn')"
                    class="p-button-info "
                   
                    style="background-color: green;"
                  />
            </div>
            <div class="table-header " style="padding: 7px;"  >
              <SplitButton label="ส่งออก PDF" :model="items" 
                          class="p-button-raised p-button-danger "
                          style="background-color: #f33737; "
                          ></SplitButton>
            </div>
            <!-- Doe : PDF 1/3 จบ -->

            <!-- Doe PDF เลือกได้  1/5   -->
            <div class="table-header" id="TABLE_EDIT" style="padding: 7px;"  >
                <Button
                @click="EditPDF()"
                icon="pi pi-cog"
                :label="'ตั้งค่า'"
                style="background-color: #0288D1;
                       border: 1px solid #0288D1;"
                />
            </div>
            <!-- Doe PDF เลือกได้  1/5 จบ  -->

            <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
              <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

              <!-- Doe ค้นหา  1/5 -->
              <span class="p-input-icon-left" v-if="columns_disabled && cou" >    
                    <i class="pi pi-search" />
                    <InputText
                    v-model="filter"
                    @input="searchTable()"
                    :placeholder="$t('searchHeader')"
                    />
                    
                </span>
                <span class="p-input-icon-left" v-else >
                    <i class="pi pi-search" />
                    <InputText
                    disabled
                    v-model="filter"
                    @input="searchTable()"
                    :placeholder="$t('searchHeader')"
                    />
                    
                </span>
              <!-- Doe ค้นหา  1/5 จบ-->

            </div>
          </div>
        </template>
        <!-- <template #header>
          <div class="table-header p-col-12 p-lg-3" style="margin-left: auto">
            <span class="p-input-icon-left">
              <i class="pi pi-search" /><InputText
                v-model="filters['global']"
                :placeholder="$t('searchHeader')"
              />
            </span>
          </div>
        </template> -->
        <template #empty>{{ $t("TableEmpty") }}</template>
        <!--Doe : เพิ่มลำดับ 2/4-->
        <div v-if="columns_index == true">
          <Column
            field="index"
            :header="'ลำดับ'"
            :sortable="true"
            :headerStyle="{width: '8rem',textAlign:'center'}"
          >
            <template #body="dataTable">  
              <div hidden>{{ dataTable.data.system_id }}</div>
              <div class="table_row">
                {{ dataTable.data.index }}
              </div>
              
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>
        <!--Doe : เพิ่มลำดับ 2/4 จบ-->

        <div v-if="columns_date == true">
          <Column
            field="date"
            :header="$t('id_help_receive')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              {{ dataTable.data.date }}
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_event_name == true">
          <Column
            field="event_name"
            :header="$t('event_name')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              {{ dataTable.data.event_name }}
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_Name_all == true">
          <Column
            field="Name_all"
            :header="$t('iv_victim_name')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              {{ dataTable.data.v_prefix }} {{ dataTable.data.firstname }} {{ dataTable.data.lastname }}
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_v_gender == true">
          <Column
            field="v_gender"
            :header="$t('iv_member_table_gender')"
            :sortable="true"
            :headerStyle="{width: '15rem',textAlign:'center'}"
          >
            <template #body="dataTable">
              <div class="table_row">
                {{ dataTable.data.v_gender }}
              </div>
              
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_age == true">
          <Column
            field="age"
            :header="$t('iv_member_table_age')"
            :sortable="true"
            :headerStyle="{width: '15rem',textAlign:'center'}"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.age != '0'">
                <div class="table_row">
                  {{ dataTable.data.age }}
                </div>
                
              </div>
              <div v-else> - </div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>
        
        <div v-if="columns_status_name == true">
          <Column
            field="status_name"
            :header="$t('iv_victim_status')"
            :sortable="true"
            :headerStyle="{width: '15rem',textAlign:'center'}"
          >
            <template #body="dataTable">
              <div class="table_row">
                {{ dataTable.data.status_name }}
              </div>
              
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_P_all == true">
          <Column
            field="P_all"
            :header="$t('address_locate')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.province_name != null"> {{ dataTable.data.province_name }}, {{ dataTable.data.amphur_name }}, {{ dataTable.data.tambon_name }}</div>
              <div v-else> - </div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_basic_help == true"> 
          <Column
            field="basic_help"
            :header="$t('iv_submodal_basichelp_topic')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.basic_help != '0.00'">
                {{ dataTable.data.basic_help }}
              </div>
              <div v-else> - </div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>
        
        <div v-if="columns_other_help_money == true"> 
          <Column
            field="other_help_money"
            :header="$t('iv_submodal_otherhelp_topic')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.other_help != '[]'">
                {{sum_other(JSON.parse(dataTable.data.other_help))}}
              </div>
              <div v-else> - </div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_damage_estimate == true">
          <Column
            field="damage_estimate"
            :header="$t('iv_submodal_damage_topic')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.damage != '[]'">
                {{sum_damage(JSON.parse(dataTable.data.damage))}}
              </div>
              <div v-else> - </div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_F_header == true">
          <Column
            field="F_header"
            :header="$t('iv_table_headerFamily')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.header == '1'">
                {{ dataTable.data.v_prefix }} {{ dataTable.data.firstname }} {{ dataTable.data.lastname }}
              </div>
              <div v-else> - </div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_family_help == true">  
          <Column
            field="family_help"
            :header="$t('iv_modal_help_topic')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.family_help != '0.00'">
                {{ dataTable.data.family_help }}
              </div>
              <div v-else> - </div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

      </DataTable>
    </div>

    <Dialog  :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <!-- Doe PDF เลือกได้  -->
    <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" 
    :style="{ width: '25rem' }"  
    :contentStyle="{ 'overflow-y': 'visible' }"
    > 
    <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
        <div style="margin: 2.5rem 1rem 0 1rem;">
          <div class="p-formgrid p-grid">
              <div class="p-field p-col-12">
          
                      <MultiSelect
                        v-model="columnsSelectorDialog"
                        :options="columns"
                        optionLabel="title"
                        :placeholder="$t('placeholderSelectBox')"
                        :filter="true"
                        class="multiselect-custom"
                        :clearFilterMultiSelect="multiSelectClearFilerValue"
                      >
                        <template #value="slotProps">
                          <div
                            class="item item-value"
                            v-for="option of slotProps.value"
                            :key="option.dataKey"
                          >
                            <div>{{ option.title }}</div>
                          </div>
                          <template
                            v-if="!slotProps.value || slotProps.value.length === 0"
                          >
                            {{ $t("placeholderSelectBox") }}
                          </template>
                        </template>
                        <template #option="slotProps">
                          <div class="item">
                            <div >{{ slotProps.option.title }}</div>
                          </div>
                        </template>
                      </MultiSelect>
                      <div style="margin-top: 1rem; 
                                  display:flex;
                                  justify-content: flex-end;">
                        <Button
                        @click="ClearEditPDF()
                                multiSelectClearFilerValue +=1"
                        class="p-button-clear"
                        :label="'ล้างข้อมูล'"
                        style="margin-right: 1rem;"
                        />
                        <Button
                        @click="SelectAllEditPDF()"
                        class="p-button-info"
                        :label="'เลือกทั้งหมด'"
                        

                        />
                      </div>
                      
              </div>
          </div>
        </div>
        <template #footer>
          <div>
            <Button
            @click="CloseEditPDF()"
            :label="'ยกเลิก'"
            icon="pi pi-times"
            class="p-button-text"
            />
            <Button
            @click="SaveEditPDF()"
            :label="'บันทึก'"
            icon="pi pi-check"
            class="p-button-text"
            />
          </div>
        </template>
      
      </Dialog>
       <!-- Doe PDF เลือกได้ -->

  </div>
</template>

<script>
import disasterEventMultiselect from "../DisasterEventMultiselect";
import responseAreaTable from "../ResponseAreaTable";
// Doe : PDF 2/3 
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';

// Doe : PDF 2/3 จบ
import moment from "moment";
import textFooter from "../../../mixins/textFooter_Search_html"
 
export default {
  name: "report-victim-detail",
  components: {
    responseAreaTable,
    disasterEventMultiselect,
    textFooter
  },
  data() {
    return {
      multiSelectClearFilerValue:0,
      date: moment().locale('th').add(543, 'year').format('l'),
      // Doe ค้นหา  2/5 
      filter:"",
      cou:false,
      cloneTable:[],
      // Doe ค้นหา  2/5 จบ

      table: [],
      filters: {},
      displayConfirmation: false,
      showDisasterEvent: false,
      showResponseArea: false,

      selectedEventData: null,
      event_table: [],

      selectedResponseAreaData: null,
      responseArea_table: [],

      eventDelete: null,
      responseAreaDelete: null,

      checked: [],

      parentmessage_event: null,
      parentmessage_area: null,
      loading: false,

      // Doe PDF เลือกได้  2/5
      setPDF_Hor:"l",
      setPosition_Hor:[802,34,802,570],
      setPDF_Ver:"p",
      setPosition_Ver:[570,34,575,815],
      setPDF_Styles:"grid",
      setnamePDF:"ตารางรายละเอียด",
      setPDF_fillColor:[95,154,250],
      setPDF_Margin:{ left: 15 ,right: 15 },

      PDF_minCellWidthVer: 50,
      PDF_FontHeaderVer:9,
      PDF_FontBodyVer:7,

      PDF_BodySizeSelect:{},
      PDF_BodySize:{
                    index: {cellWidth: 25},
                    date:{cellWidth:42},
                    v_gender:{cellWidth:28},
                    age:{cellWidth:28},
                    status_name:{cellWidth:35},
                    damage_estimate:{cellWidth:43},
                    basic_help:{cellWidth:43},
                    other_help_money:{cellWidth:45},
                    F_header:{cellWidth:55},
                    family_help:{cellWidth:45}
      },
      
      PDF_minCellWidthHor: 70,
      PDF_FontHeaderHor:12,
      PDF_FontBodyHor:10,

      PDF_BodySizeHorSelect:{},
      PDF_BodySizeHor:{
                          index: {cellWidth: 32},
                          date:{cellWidth:67},

                          v_gender:{cellWidth:32},
                          age:{cellWidth:32},
                          status_name:{cellWidth:43},
                          basic_help:{cellWidth:55},
                          damage_estimate:{cellWidth:56},
                          family_help:{cellWidth:55}
      },
      columns:[
      {title: "ลำดับ", dataKey: "index" },
                  {title: "วัน-เวลาที่รับแจ้งเหตุ", dataKey: "date" },
                  {title: "ชื่อเหตุการณ์", dataKey: "event_name" },
                  {title: "ชื่อผู้ประสบภัย", dataKey: "Name_all"},
                  {title: "เพศ", dataKey: "v_gender"},
                  {title: "อายุ", dataKey: "age"},
                  {title: "สถานภาพ", dataKey: "status_name"},
                  {title: "พื้นที่ตามที่อยู่", dataKey: "P_all"},
                  {title: "การช่วยเหลือเบื้องต้น", dataKey: "basic_help"},
                  {title: "การช่วยเหลืออิ่นๆ", dataKey: "other_help_money"},
                  {title: "ความเสียหาย(ทรัพย์สิน)", dataKey: "damage_estimate"},
                  {title: "หัวหน้าครอบครัว", dataKey: "F_header"},
                  {title: "การช่วยเหลือครอบครัว", dataKey: "family_help"},

              ],

      columnsSelector:null,
      columnsSelectorDialog:null,
      
      displayEditPDF:false,

      columns_index:true,
      columns_date:true,
      columns_event_name:true,
      columns_Name_all:true,
      columns_v_gender:true,
      columns_age:true,
      columns_status_name:true,
      columns_P_all:true,

      columns_basic_help:true,
      columns_other_help_money:true,
      columns_damage_estimate:true,
      columns_F_header:true,
      columns_family_help:true, 

      columns_disabled:true,
      GetData_ColumnsSearch:[],
      // Doe PDF เลือกได้  2/5  จบ

      // 
      text_Footer:false,
      Clone_Data_text_Footer:[],
      Data_text_Footer:[
        {
          DataName:"สถานภาพ",
          textShow:"",
        },
        {
          DataName:"เหตุการณ์สาธารณภัย",
          textShow:"",
        },
        {
          DataName:"พื้นที่ตามที่อยู่",
          textShow:"",
        },
      ],

      // Doe : PDF 3/3
      items: [
				{
					label: ' แนวตั้ง',	
					command: () => {
            
            if(this.table == ""){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวตั้ง', life: 3000});

              let columns = this.columnsSelector

              const Body_setCenter = ["index","v_gender","age","status_name"]
              
              const PintPDF = {
                streak:this.setPDF_Ver,
                setPosition:this.setPosition_Ver,
                PDF_Styles:this.setPDF_Styles,
                data:this.$refs.dt.processedData,
                columns:columns,
                columnsStyles:this.PDF_BodySizeSelect,
                FileName:this.setnamePDF,
                checkBody_Center:true,
                Body_Center:Body_setCenter,
                Col_FontSize:this.PDF_FontHeaderVer,
                Body_FontSize:this.PDF_FontBodyVer,
                minCell:this.PDF_minCellWidthVer,
                marginPDF:this.setPDF_Margin,
                fillColorPDF:this.setPDF_fillColor,
              }
              this.printPDF(PintPDF)

            }
              }
            },
			
				{
					label: 'แนวนอน',
					command: () => {
            if(this.table == ""){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวนอน', life: 3000});
            
            let columns = this.columnsSelector

              const Body_setCenter = ["index","v_gender","age","status_name"]
              
              const PintPDF = {
                streak:this.setPDF_Hor,
                setPosition:this.setPosition_Hor,
                PDF_Styles:this.setPDF_Styles,
                data:this.$refs.dt.processedData,
                columns:columns,
                columnsStyles:this.PDF_BodySizeHorSelect,
                FileName:this.setnamePDF,
                checkBody_Center:true,
                Body_Center:Body_setCenter,
                Col_FontSize:this.PDF_FontHeaderHor,
                Body_FontSize:this.PDF_FontBodyHor,
                minCell:this.PDF_minCellWidthHor,
                marginPDF:this.setPDF_Margin,
                fillColorPDF:this.setPDF_fillColor,
              }
              this.printPDF(PintPDF) 
            } 
            }
          },
        ],
      // Doe : PDF 3/3 จบ
    };
  },
  watch: {
    showDisasterEvent(val){
      if(val == true){
        if(this.event_table.length > 0){
          this.parentmessage_event = this.event_table
        }else{
          this.parentmessage_event = []
        }
      }
    },

    showResponseArea(val){
      if(val == true){
        if(this.responseArea_table.length > 0){
          this.parentmessage_area = this.responseArea_table
        }else{
          this.parentmessage_area = []
        }
      }
    },

    table(val){
      if(val.length>0){
        this.loading = false
      }else{
        this.loading = false
      }
    },
    // Doe PDF เลือกได้
    columnsSelector(val){
      
      if (val.length == 0) {
        this.table = []
      }else{
        this.table = this.cloneTable
      }
    },
  },
  created() {
    // Doe PDF เลือกได้  4/5  
    this.columnsSelector = this.columns
      this.PDF_BodySizeSelect = this.PDF_BodySize
      this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor

      // Doe PDF เลือกได้  4/5  จบ

    this.checked = ['0','gs-99die','gs-99hurt','gs-99lost']

    this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer)

  },
  mounted() {},
  methods: {
        exportCSV() {
          if (this.table != "") {
      debugger
      this.$refs.dt.exportCSV();
          }
    },
    sum_other(val){
      var temp=0
      for(let i=0; i<val.length; i++){
        temp += Number(val[i].money)
      }
      return parseFloat(temp).toFixed(2)
    },

    sum_damage(val){
      var temp=0
      for(let i=0; i<val.length; i++){
        temp += Number(val[i].estimate)
      }
      return parseFloat(temp).toFixed(2)
    },

    selectedEvent_passValue(variable) {
      this.showDisasterEvent = false;
      // console.log(variable);
      if (variable != null) {
        this.event_table = []
        for (let i = 0; i < variable.length; i++) {
          var date = new Date(variable[i].event_date);
          // const y = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
          //   date
          // );
          // const m = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
          //   date
          // );
          // const d = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
          //   date
          // );
          // var event_date = `${d}/${m}/${y}`;
          
          //แก้ วันที่
          var e_date =[]
          if (JSON.stringify(variable[i].event_date).length == 26) {
             e_date = `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`
          }
          if(JSON.stringify(variable[i].event_date).length <= 12){
             e_date = variable[i].event_date
          }
          this.event_table.push({
            hazard_id: variable[i].hazard_id,
            event_date: e_date,
            event_name: variable[i].event_name,
          });
          // console.log("this.event_table",(JSON.stringify(variable[i].event_date).length))
        }
      }
    },

    selectResponseArea_passValue(variable) {
      this.showResponseArea = false;
      if (variable != null) {
        this.responseArea_table = []
        for (let i = 0; i < variable.length; i++) {
          this.responseArea_table.push(variable[i]);
        }
      }
    },

    // Doe ค้นหา  3/6 
    searchTable(){
      this.ms = true
      if (this.filter != "") {
        // console.log("4444")
        this.table = this.cloneTable.filter((item) => {
          if (item.level_name == null || item.level_name == "null") {
                    item.level_name = "-"
                  }
              return (this.columns_date ? item.date.includes(this.filter) : "") ||
                 (this.columns_event_name ? item.event_name.includes(this.filter) : "") ||
                 (this.columns_Name_all ? item.Name_all.includes(this.filter) : "") ||
                 (this.columns_v_gender ? item.v_gender.includes(this.filter) : "") ||
                 (this.columns_age ? item.age.includes(this.filter) : "") ||
                 (this.columns_status_name ? item.status_name.includes(this.filter) : "") ||
                 (this.columns_P_all ? item.P_all.includes(this.filter) : "") ||
                 (this.columns_basic_help ? item.basic_help.includes(this.filter) : "") ||
                 (this.columns_other_help_money ? item.other_help_money.includes(this.filter) : "") ||
                 (this.columns_damage_estimate ? item.damage_estimate.includes(this.filter) : "") ||
                 (this.columns_F_header ? item.F_header.includes(this.filter) : "") ||
                 (this.columns_family_help ? item.family_help.includes(this.filter) : "")  

      });

      for (let i = 0; i < this.table.length; i++) { 
        this.table[i]["index"] =i+1;
      }

      return (this.table)

      }else{
        // console.log("5555")
      this.table = this.cloneTable
      for (let i = 0; i < this.table.length; i++) { 
        this.table[i]["index"] =i+1;
      }
      }
      this.table = this.cloneTable
    },
    // Doe ค้นหา  3/6 จบ

    async search() {
      this.filter='';
      this.cloneTable=[];
      this.loading = true
      await this.axios
        .post(`${this.$url_service}/get/report`, { 
          body: { 
            topic: 'get-report-victim',
            subtopic: 'get-report-victim-detail',
            event: this.event_table,
            location: this.responseArea_table,
            status: this.checked,
            start_date: '', end_date: '', disaster: ''
          } 
      }).then((response) => {
        // console.log(response.data.data,)
        this.table = response.data.data
        // Doe ค้นหา  4/6 
        this.cloneTable = response.data.data
            // Doe ค้นหา  4/6

        // console.log("table ",this.table)
        // Doe: เพิ่มลำดับ 3
        for (let i = 0; i < this.table.length; i++) { 
          this.table[i]["index"] =i+1;
          }

        // Doe: เพิ่มลำดับ 3 จบ
              
        // Doe: รวมจังหวัด
          var data1 = this.table.map(obj => 
              data1= obj.province_name)
              
            var data2 = this.table.map(obj => 
              data2= obj.amphur_name)

            var data3 = this.table.map(obj => 
              data3= obj.tambon_name)

              // console.log('data1 ',data1);
              // console.log('data2 ',data2);
              // console.log('data3 ',data3);
          
            for (let index = 0; index < data1.length; index++) {
              
              if (data1[index] == null) {
                data1[index] = "-"
              }
              const element = data1[index];

              if (data2[index] == null) {
                data2[index] = "-"
              }
              const element2 = data2[index];
              if (data3[index] == null) {
                data3[index] = "-"
              }
              const element3 = data3[index];

              // const element = data1[index];
              // const element2 = data2[index];
              // const element3 = data3[index];

              let textAll = ''
                  if (element == "-" && element2 == "-" && element3 == "-" ) {
                    textAll += `-`;
                  }else{
                    textAll += `${element}, ${element2}, ${element3}`;
                  }
                  
  
                this.table[index]["P_all"] = textAll
              }
          // Doe: ชื่อ
          var data4 = this.table.map(obj => 
              data4= obj.v_prefix)
              
            var data5 = this.table.map(obj => 
              data5= obj.firstname)

            var data6 = this.table.map(obj => 
              data6= obj.lastname)

              // console.log('data1 ',data1);
              // console.log('data2 ',data2);
              // console.log('data3 ',data3);
          
            for (let index = 0; index < data1.length; index++) {
              const element = data4[index];
              const element2 = data5[index];
              const element3 = data6[index];

              let textAll = ''
              if (element == null) {
                    textAll += `${element2} ${element3}`;
                  }else{
                    textAll += `${element} ${element2} ${element3}`;
                  }
                this.table[index]["Name_all"] = textAll
              }
            
          // Doe: หัวหน้าครอบครัว
          var data9 = this.table.map(obj => 
                data9= obj.header)
          // console.log('data9 ',data9);
          for (let index = 0; index < data9.length; index++) {
            const header = data9[index];
            const element = data4[index];
            const element2 = data5[index];
            const element3 = data6[index];
            let textAll = ''

            if (header==1) {
              // console.log(header)
              if(element == null){
                textAll += `${element2} ${element3}`;
              }else{
                textAll += `${element} ${element2} ${element3}`;
              }
              
            }
            this.table[index]["F_header"] = textAll
            
          }

            // รวม การช่วยเหลืออื่นๆ
          let data7 = this.table.map(obj => 
              data7= obj.other_help)
          
          for (let index = 0; index < data7.length; index++) {
              const element = data7[index];
                  // console.log('element > 1 ',index,'=',element);
                  // console.log('element > 1 ',index,'=',JSON.parse(element).length);
                  let textAll = ''
                      for (let index = 0; index <JSON.parse(element).length; index++) {

                        const element2 = JSON.parse(element)[index].money;
                        // console.log('element2 ',element2);
                        textAll += `${element2}`;
                      }
                      this.table[index]["other_help_money"] = textAll
                // console.log("**** ",this.table)
              }
          // รวม ความเสียหาย(ทรัพย์สิน)
          let data8 = this.table.map(obj => 
              data8= obj.damage)
              // console.log("888 ",data8)

          for (let index = 0; index < data8.length; index++) {
              const element = data8[index];
                  // console.log('element > 1 ',index,'=',element);
                  // console.log('element > 1 ',index,'=',JSON.parse(element).length);
                  let textAll = ''
                      for (let index = 0; index <JSON.parse(element).length; index++) {

                        const element2 = JSON.parse(element)[index].estimate;
                        // console.log('element2 ',element2);
                        textAll += `${element2}`;
                      }
                      this.table[index]["damage_estimate"] = textAll
                // console.log("**** ",this.table)
              }
          // Doe : แก้ไข เวลา
          for (let index = 0; index < this.table.length; index++) {
            const element = this.table[index].date.split("/");
            // console.log("element",element)
            let dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`)
            // console.log("dateNew",dateNew)

            // let result_Date = dateNew.toLocaleDateString('th-TH', {
            //   year: 'numeric',
            //   month: 'long',
            //   day: 'numeric',
            //   hour: 'numeric',
            //   minute: 'numeric',
            //   second:'numeric'
            // })
         
          // console.log("result_DateStart", moment(dateNew).locale('th').format("lll")) 
          this.table[index].date = moment(dateNew).locale('th').add(543, 'year').format("LLL")
          }
           // Doe : แก้ไข เวลา
          // console.log("this.table",this.table)


          // Doe ช่องว่างใส่ ขีด
          for (let index = 0; index < this.table.length; index++) {

              if (this.table[index].age == null ||
                  this.table[index].age == "null" ||
                  this.table[index].age == "0"||
                  this.table[index].age == 0 ) {
                this.table[index].age = "-"
              }
              if (this.table[index].other_help_money == null ||
                  this.table[index].other_help_money == "null" ||
                  this.table[index].other_help_money == "" ) {
                this.table[index].other_help_money = "-"
              }
              if (this.table[index].damage_estimate == null ||
                  this.table[index].damage_estimate == "null" ||
                  this.table[index].damage_estimate == "" ) {
                this.table[index].damage_estimate = "-"
              }
              if (this.table[index].header == null ||
                  this.table[index].header == "null" ||
                  this.table[index].header == "" ||
                  this.table[index].header == 0) {
                this.table[index].F_header = "-"
              }

          }
          // Doe ช่องว่างใส่ ขีด

          this.setSearchText_Footer()

      });

      if (this.columns_disabled == true) {
            this.table = this.cloneTable
      }else{
            this.table = []
      }

      this.loading = false;
    },
    setSearchText_Footer(){
          this.text_Footer=false;

          this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
          if (this.checked.length !== 0 ||
              this.responseArea_table.length !== 0 ||
              this.event_table.length !== 0   ) {
              for (let index = 0; index < this.Data_text_Footer.length; index++) {
                const element = this.Data_text_Footer[index];
                if(element.DataName === "สถานภาพ" && this.checked.length !== 0){
                  element.textShow = this.setArray_to_Text(this.checked,null)
                }
                if(element.DataName === "เหตุการณ์สาธารณภัย" && this.event_table.length !== 0){
                  element.textShow = this.setArray_to_Text_Double(this.event_table,"event_date","event_name")
                }
                if(element.DataName === "พื้นที่ตามที่อยู่" && this.responseArea_table.length !== 0){
                  element.textShow = this.setArray_to_Text_PAT(this.responseArea_table,"province_name","amphur_name","tambon_name")
                }

                this.text_Footer=true;
              }
          }
    },
    setArray_to_Text_Double(data,name1,name2){
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        text += " วันที่ : " + this.formatDateTH(element[name1]) + " ชื่อเหตุการณ์ : " + element[name2]+ ","
      }
      
      return  text.slice(0, -1)
    },
    setArray_to_Text(data,name){
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (name !== null) {
          if (element[name] !== undefined) {
            text += element[name] + ",";
          }
        }else{
          if (element === "0") {
            text += "ไม่ระบุ" + ",";
          }else if (element === "gs-99die") {
            text += "เสียชีวิต" + ",";
          }else if (element === "gs-99hurt") {
            text += "บาดเจ็บ" + ",";
          }else if (element === "gs-99lost") {
            text += "สูญหาย" + ",";
          }
          
        }
      }
      return text.slice(0, -1)
    },
    setArray_to_Text_PAT(data,name_P,name_A,name_T){
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (name_P !== null) {
          if (element[name_P] !== undefined) {
            text += "จังหวัด : "+element[name_P] + " ";
          }
          if (element[name_A] !== undefined) {
            text += "เขต/อำเภอ : "+element[name_A] + " ";
          }
          if (element[name_T] !== undefined) {
            text += "แขวง/ตำบล : "+element[name_T] + ",";
          }
        }else{
          text += element + ",";
        }
      }
      return text.slice(0, -1)
    },

    confirmDelete() {
      if (this.eventDelete != null) {
        this.event_table = this.event_table.filter(
          (val) => val !== this.eventDelete
        );
      }
      if (this.responseAreaDelete != null) {
        this.responseArea_table = this.responseArea_table.filter(
          (val) => val !== this.responseAreaDelete
        );
      }
      this.displayConfirmation = false;
      this.eventDelete = null;
      this.responseAreaDelete = null;
    },

    clearSearchField() {
      this.event_table = [];
      this.responseArea_table = [];
      this.checked = [];
      this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
      this.text_Footer=false;
      // Doe ค้นหา
      this.filter='';
      this.table = [];
      this.cloneTable=[];
    },
    alertDisplay(temp) {
      this.$fire({
                    title: "ยืนยันการลบข้อมูล",
                    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    // console.log(temp)
                    if (result.value) {
                      // console.log("temp",temp)
                      this.confirmDelete(temp)
                    }
                  })
    },

    // Doe PDF เลือกได้  5/5  
    EditPDF(){
        this.displayEditPDF = true
        this.columnsSelectorDialog = this.columnsSelector
        
      },
      SaveEditPDF(){

        if(this.columnsSelectorDialog.length <= 4){
        this.PDF_minCellWidthVer = 120 
        this.PDF_FontHeaderVer = 15
        this.PDF_FontBodyVer = 12
       
        this.PDF_BodySizeSelect = {
          index: {cellWidth: 35},
        }

        this.PDF_minCellWidthHor = 130
        this.PDF_FontHeaderHor = 15
        this.PDF_FontBodyHor = 12

        this.PDF_BodySizeHorSelect = {
          index: {cellWidth: 35},
        }
      }else if(this.columnsSelectorDialog.length <= 6){
        
        this.PDF_minCellWidthVer = 70
        this.PDF_FontHeaderVer = 15
        this.PDF_FontBodyVer = 12
        this.PDF_BodySizeSelect = {
          index: {cellWidth: 35},
          date:{cellWidth:55},
        } 

        this.PDF_minCellWidthHor = 90
        this.PDF_FontHeaderHor = 15
        this.PDF_FontBodyHor = 12
        
        this.PDF_BodySizeHorSelect = {
          index: {cellWidth: 35},

        }
      }else if(this.columnsSelectorDialog.length <= 9){
        this.PDF_minCellWidthVer = 65
        this.PDF_FontHeaderVer = 11
        this.PDF_FontBodyVer = 8
        this.PDF_BodySizeSelect = {
          date:{cellWidth:50},
          index: {cellWidth: 30},
          damage_estimate:{cellWidth:50},
          basic_help:{cellWidth:50},
          other_help_money:{cellWidth:50},
          // F_header:{cellWidth:65},
          family_help:{cellWidth:50}
        } 

        this.PDF_minCellWidthHor = 70
        this.PDF_FontHeaderHor = 12
        this.PDF_FontBodyHor = 10
        
        this.PDF_BodySizeHorSelect = {
          index: {cellWidth: 32},
        }
      }else if(this.columnsSelectorDialog.length <= 11){
        this.PDF_minCellWidthVer = 55
        this.PDF_FontHeaderVer = 9
        this.PDF_FontBodyVer = 7
        this.PDF_BodySizeSelect = {
                    index: {cellWidth: 28},
                    date:{cellWidth:42},
                    v_gender:{cellWidth:28},
                    age:{cellWidth:28},
                    status_name:{cellWidth:35},
                    damage_estimate:{cellWidth:43},
                    basic_help:{cellWidth:43},
                    other_help_money:{cellWidth:45},
                    // F_header:{cellWidth:55},
                    family_help:{cellWidth:45}
        } 

        this.PDF_minCellWidthHor = 70
        this.PDF_FontHeaderHor = 12
        this.PDF_FontBodyHor = 10
        
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor
      }else{
        this.PDF_minCellWidthVer = 50
        this.PDF_FontHeaderVer = 9
        this.PDF_FontBodyVer = 7
        this.PDF_BodySizeSelect = this.PDF_BodySize

        this.PDF_minCellWidthHor = 73
        this.PDF_FontHeaderHor = 12
        this.PDF_FontBodyHor = 10
        
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor
      }
        
      this.columnsSelector = this.columnsSelectorDialog

        if (this.columnsSelectorDialog.length == 0) {
          
          this.columns_index = false
          this.columns_date = false
          this.columns_event_name = false
          this.columns_Name_all = false
          this.columns_v_gender = false
          this.columns_age = false
          this.columns_status_name = false
          this.columns_P_all = false

          this.columns_basic_help = false
          this.columns_other_help_money = false
          this.columns_damage_estimate = false
          this.columns_F_header = false
          this.columns_family_help = false

          this.columns_disabled = false
        }else if(this.columnsSelectorDialog.length == 13){
            
            this.columns_index = true
            this.columns_date = true
            this.columns_event_name = true
            this.columns_Name_all = true
            this.columns_v_gender = true
            this.columns_age = true
            this.columns_status_name = true
            this.columns_P_all = true

            this.columns_basic_help = true
            this.columns_other_help_money = true
            this.columns_damage_estimate = true
            this.columns_F_header = true
            this.columns_family_help = true
            
            this.columns_disabled = true
        }  
        else{
          this.columns_disabled = true
          // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);
          
          
          let getData = []    
          // ! จัดข้อมูล
          for (let index = 0; index < this.columnsSelector.length; index++) {
            getData.push(this.columnsSelector[index].dataKey);
          }
          
          // console.log("getData",getData);

          // ! เช็คข้อมูล

          for (let index = 0; index < this.columnsSelector.length; index++) {
              const element = this.columnsSelector[index].dataKey
        
              if (element == "index") {
                this.columns_index = true
              } else if(!getData.includes("index")){
                // console.log("getData.includes(index)",getData.includes("index"))
                this.columns_index = false
              }

              if (element == "date") {
                this.columns_date = true 
              }else if(!getData.includes("date")){
                
                this.columns_date = false
              }

              if (element == "event_name") {
                this.columns_event_name = true 
              }else if(!getData.includes("event_name")){
                
                this.columns_event_name = false
              }

              if (element == "Name_all") {
                this.columns_Name_all = true 
              }else if(!getData.includes("Name_all")){
                
                this.columns_Name_all = false
              }

              if (element == "v_gender") {
                this.columns_v_gender = true 
              }else if(!getData.includes("v_gender")){
                
                this.columns_v_gender = false
              }

              if (element == "age") {
                this.columns_age = true 
              }else if(!getData.includes("age")){
                
                this.columns_age = false
              }

              if (element == "status_name") {
                this.columns_status_name = true
              } else if(!getData.includes("status_name")){
                this.columns_status_name = false
              }

              if (element == "P_all") {
                this.columns_P_all = true 
              }else if(!getData.includes("P_all")){
                
                this.columns_P_all = false
              }

              if (element == "basic_help") {
                this.columns_basic_help = true 
              }else if(!getData.includes("basic_help")){
                
                this.columns_basic_help = false
              }

              if (element == "other_help_money") {
                this.columns_other_help_money = true 
              }else if(!getData.includes("other_help_money")){
                
                this.columns_other_help_money = false
              }

              if (element == "damage_estimate") {
                this.columns_damage_estimate = true 
              }else if(!getData.includes("damage_estimate")){
                
                this.columns_damage_estimate = false
              }

              if (element == "F_header") {
                this.columns_F_header = true 
              }else if(!getData.includes("F_header")){
                
                this.columns_F_header = false
              }

              if (element == "family_help") {
                this.columns_family_help = true
              } else if(!getData.includes("family_help")){
                this.columns_family_help = false
              }

          }

        }

        this.displayEditPDF = false
        this.filter = ""

      },
      CloseEditPDF(){
        this.displayEditPDF = false
      },
      ClearEditPDF(){
        this.columnsSelectorDialog = []
        
      },
      SelectAllEditPDF(){
        this.columnsSelectorDialog = this.columns
        
      },
      // Doe PDF เลือกได้  5/5 จบ

  },

  computed: {
    
  }
};
</script>

<style scoped>

.table_row{
  text-align: center;
}

@media screen and (min-width: 819px) and (max-width: 1200px)  {
  #Search{
      width: 20rem;
    }
}
/* // Doe PDF เลือกได้ */
#TABLE_EDIT{
    width: 149px;
  }
@media screen and (max-width: 818px) {
    #Search{
      width: 100%;
    }
}
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
.p-multiselect {
  min-width: 15rem;
}

.multiselect-custom {
   // Doe PDF เลือกได้
   width: 100%;
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .item {
    display: flex;
    align-items: center;
  }

  .item-value {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 3px;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
}
</style>
